import { createEntityAdapter } from "@reduxjs/toolkit";
import { apiSlice } from "../../../app/api/apiSlice";

const chartAdapter = createEntityAdapter({
  selectId: (sale) => sale.id,
});

const initialState = chartAdapter.getInitialState();

export const extendedApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getSalesChartDataByUserId: builder.query({
      query: ({ userId, type }) => `/DashboardChart/sales/${userId}/${type}`,
      transformResponse: (responseData) => {
        return chartAdapter.setAll(initialState, responseData);
      },
      providesTags: (result, error, arg) => [
        { type: "SalesChart", id: "LIST" },
        ...result.ids.map((id) => ({ type: "SalesChart", id })),
      ],
    }),
    getBookedOrdersChartDataByUserId: builder.query({
      query: ({ userId, type }) =>
        `/DashboardChart/booked_orders/${userId}/${type}`,
      transformResponse: (responseData) => {
        return chartAdapter.setAll(initialState, responseData);
      },
      providesTags: (result, error, arg) => [
        { type: "BookedOrdersChart", id: "LIST" },
        ...result.ids.map((id) => ({ type: "BookedOrdersChart", id })),
      ],
    }),
    getIndividualTargetsChartDataByUserId: builder.query({
      query: ({ userId, type }) =>
        `/DashboardChart/individual_targets/${userId}/${type}`,
      transformResponse: (responseData) => {
        return chartAdapter.setAll(initialState, responseData);
      },
      providesTags: (result, error, arg) => [
        { type: "IndividualTargetsChart", id: "LIST" },
        ...result.ids.map((id) => ({ type: "IndividualTargetsChart", id })),
      ],
    }),
    getCompanyTargetsChartData: builder.query({
      query: ({ type }) => `/DashboardChart/company_targets/${type}`,
      transformResponse: (responseData) => {
        return chartAdapter.setAll(initialState, responseData);
      },
      providesTags: (result, error, arg) => [
        { type: "CompanyTargetsChart", id: "LIST" },
        ...result.ids.map((id) => ({ type: "CompanyTargetsChart", id })),
      ],
    }),
    getTeamTargetData: builder.query({
      query: ({ startDate, endDate }) =>
        `DashboardChart/team_targets/custom/${startDate}/${endDate} `,

      providesTags: (result, error, arg) => [
        { type: "CompanyTeamTargets", id: "LIST" },
      ],
    }),
  }),
});

export const {
  useGetSalesChartDataByUserIdQuery,
  useGetBookedOrdersChartDataByUserIdQuery,
  useGetIndividualTargetsChartDataByUserIdQuery,
  useGetCompanyTargetsChartDataQuery,
  useGetTeamTargetDataQuery,
} = extendedApiSlice;
